const qk = {
  list: (appId?: string, envId?: string, params?: Record<string, unknown>) =>
    [
      "apps",
      appId,
      "environments",
      envId,
      "users",
      ...(params ? [params] : []),
    ] as const,

  single: (appId?: string, envId?: string, userId?: string) =>
    [...qk.list(appId, envId), userId] as const,

  flags: (appId?: string, envId?: string, userId?: string) =>
    [...qk.single(appId, envId, userId), "flags"] as const,
};

export { qk as userQueryKeys };
